import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { catchError, concatMap, from, of, Subject, tap, toArray } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VolunteersImportService {

  public takeUntilSubject: Subject<any> = new Subject();

  public existingVolunteerList: any[] = [];
  public volunteerList: any[] = [];

  public successfulCount: number = 0;
  public failedCount: number = 0;

  addVolunteer(volunteer) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `email=${encodeURIComponent(volunteer.email)}`
    ];
  
    volunteer.statusText = '<span class="subtitle-2 font-italic grey-text">Processing…</span>';
    volunteer.statusIcon = '<i class="fas fa-spinner checkout-spinner"></i>';
  
    return this.http.post('/api/addVolunteer', queryParams.join("&"), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }

  addVolunteerList(volunteerList) {
    const list = [...volunteerList];
    this.successfulCount = 0;
    this.failedCount = 0;
  
    return from(list).pipe(
      concatMap((volunteer, index) =>
        this.addVolunteer(volunteer).pipe(
          tap((response: any) => {
            // check if email adready exists because server does not throw an error in this case
            const emailAlreadyExist = this.existingVolunteerList.find(item => item.email === volunteer?.email);
            if (emailAlreadyExist) {
              throw new Error('Volunteer with this email already exists');
            } else if (response?.success) {
              this.successfulCount += 1;

              volunteer.statusText = '<span class="subtitle-2 green-text">Completed</span>';
              volunteer.statusIcon = '<i class="fas fa-check-circle green-text"></i>';
              volunteer.statusMessage = '';
            }
          }),
          catchError((error) => {
            this.failedCount += 1

            volunteer.statusText = '<span class="subtitle-2 red-text">Failed</span>';
            volunteer.statusIcon = '<i class="fas fa-exclamation-triangle red-text"></i>';
            volunteer.statusMessage = `<span class="body-2 red-text">${error.message || 'Error occurred'}</span>`;
            
            return of(volunteer);
          }),
        )
      ),
      toArray()
    );
  }

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) { }
}
